import { render, staticRenderFns } from "./AdministrarDaesComponent.vue?vue&type=template&id=4e65410e&"
import script from "./AdministrarDaesComponent.vue?vue&type=script&lang=js&"
export * from "./AdministrarDaesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports